import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=30e3e196&scoped=true&"
import script from "./Criteria.vue?vue&type=script&lang=js&"
export * from "./Criteria.vue?vue&type=script&lang=js&"
import style0 from "./criteria.scss?vue&type=style&index=0&id=30e3e196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e3e196",
  null
  
)

export default component.exports